<app-loader *ngIf="loadingImage"></app-loader>
<img *ngIf="!loadingImage" [src]="imageBytes" alt="image">


